module.exports = __webpack_public_path__ + "342d020e7e6cdcc7ccea94d4976d5aab.jpeg";